import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-a64a8a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full md:w-auto block md:hidden flex items-center justify-end gap-1"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 0,
  class: "block md:hidden"
}
const _hoisted_4 = {
  key: 1,
  class: "lg:flex md:justify-between pt-6"
}
const _hoisted_5 = { class: "flex flex-1 justify-between pb-6 md:pb-3" }
const _hoisted_6 = { class: "flex pb-6 lg:hidden flex-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex text-light-secondary flex-1 md:justify-end" }, null, -1))

import ApiHelper from "@/helpers/apiHelper";
import SwitchButton from '@/components/atoms/SwitchButton.vue'
import ButtonPrimary from '@/components/atoms/ButtonPrimary.vue';
import {onMounted, ref, withDefaults} from 'vue'
import {useSearchTranslatorFiltersStore} from "@/stores/searchTranslatorFilters.store";
import {storeToRefs} from "pinia";
import AutocompletePrimary from "@/components/atoms/AutocompletePrimary.vue";
import router, {getRouteName} from "@/router";
import axios from "axios";
import storeCache from "@/helpers/storeCache";
import FindingTranslatorParamsParser from "@/helpers/findingTranslatorParamsParser";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSection',
  props: {
    sortSection: { type: Boolean },
    count: null,
    totalCount: null,
    togglingMobileFilters: { type: Boolean, default: false }
  },
  emits: ['clickSearch', 'update:chooseList', 'update:chooseMap', 'toggleSwitch'],
  setup(__props: any, { emit }) {




const chooseList = ref(true),
    chooseMap = ref(false),
    searchTranslatorFiltersStore = useSearchTranslatorFiltersStore(),
    { availableLangs, availableTranslationTypes, availableLocations, fetchAllData } = storeToRefs(searchTranslatorFiltersStore),
    chooseLang = ref(),
    translationsTypes = ref(),
    selectedLanguageObject = ref(),
    selectedTranslationTypeObject = ref(),
    selectedCityObject = ref(),
    locationObject = ref(),
    requiredLang = ref(false),
    requiredCity = ref(false),
    requiredTranslated = ref(false),
    showFilters = ref(false),
    toggleSwitch = ref(!!router.currentRoute.value.query.interpreting);

let searchTermValue = '';

function updateMap() {
    chooseList.value = false;
    chooseMap.value = true;
    emit('update:chooseMap',true);
    emit('update:chooseList',false)

}

function updateList() {
    chooseList.value = true;
    chooseMap.value = false;
    emit('update:chooseList',true)
    emit('update:chooseMap',false);
}

function searchTermCity(searchValue) {
    searchTermValue = searchValue.search;

    if(searchValue.search != locationObject.value?.name) {
        locationObject.value = '';
    }
}

function selectedTermTypes(searchValue) {
    if(searchValue.search != translationsTypes.value?.name) {
        translationsTypes.value = '';
    }
}

function searchTermLanguage(searchValue) {
    if(searchValue.search != chooseLang.value?.name) {
        chooseLang.value = '';
    }
}

function searchCity() {
    if(searchTermValue)
        return axios.get(ApiHelper.getAddressLookup(searchTermValue))
            .then(res => {
                const candidates = res.data.candidates;
                const result = candidates.map(item => {
                    return {
                        id: item.id,
                        name: item.description,
                        slug: item.slug,
                    }
                });
                storeCache.set('searchCity',result)
                return result;
            })
}

async function goToSearch() {

    requiredCity.value = locationObject.value?.name ? false : true;
    requiredLang.value = chooseLang.value?.name ? false : true;
    requiredTranslated.value = translationsTypes.value?.name ? false : true;

    if(!requiredCity.value && !requiredLang.value && !requiredTranslated.value) {
        requiredLang.value = false;
        requiredCity.value = false;
        const queryItem = (locationObject.value && (locationObject.value.lat && locationObject.value.lng)) ? {
            lat: locationObject.value.lat,
            lng: locationObject.value.lng
        } : {
            lat: router.currentRoute.value.query.lat,
            lng: router.currentRoute.value.query.lng,
        };
        const city = (locationObject.value && locationObject.value?.slug) ?? locationObject.value?.slug;
        const types = (translationsTypes.value && translationsTypes.value?.slug) ?? translationsTypes.value?.slug;

        if(locationObject.value) {
            const locationExist = availableLocations.value.filter((el: any) => {
                if(el.id == locationObject.value.id)
                    return true;
            });


            if(!locationExist.length)
                availableLocations.value.push({
                    id: locationObject.value.id,
                    name: locationObject.value.name,
                    slug: locationObject.value.slug,
                    lat: locationObject.value.lat,
                    lng: locationObject.value.lng,
                });


        }

        // toggleSwitch.value = false;

        if(router.currentRoute.value.query?.interpreting)
            queryItem.interpreting = router.currentRoute.value.query.interpreting;

        await router.push({
            name: getRouteName('findTranslator'),
            params: {language: chooseLang.value.slug, city: city, types: types},
            query: queryItem
        });

        emit('clickSearch', {
            language: chooseLang.value,
            types: translationsTypes.value,
            location: locationObject.value,
        });
    }
}

function selectedLanguage(object) {
    chooseLang.value = object.item;
    storeCache.set('searchSelectedLang',object)
    selectedLanguageObject.value = object;
}

function selectedTypes(object) {
    translationsTypes.value = object.item;
    storeCache.set('searchSelectedTranslationType',object)
    selectedTranslationTypeObject.value = object;
}

async function selectedLocation(object) {
    if(object.value && !Number.isInteger(object.value)) {
        await axios.get(ApiHelper.getAddressLookupLocation(object.value))
            .then((result: any) => {
                if (Object.keys(result.data).length) {
                    const cachedLocation = storeCache.get('searchCity');
                    const locationSlug = cachedLocation.filter(item => item.id == result.data.id);
                    object.item.lat = result.data.lat;
                    object.item.lng = result.data.lng;
                    object.item.slug = locationSlug[0]?.slug;
                }
            });
    }

    locationObject.value = object.item;
    storeCache.set('searchSelectedCity',object)
    selectedCityObject.value = object;
}

function toggleSwitchEvent(toggle) {
    toggleSwitch.value = toggle;
    emit('toggleSwitch',toggle);
}

function fetchCurrentParams() {
    const paramsParser = new FindingTranslatorParamsParser();
    paramsParser.fetchAllParams();
    selectedLanguageObject.value = storeCache.get('searchSelectedLang');
    selectedTranslationTypeObject.value = storeCache.get('searchSelectedTranslationType');
    selectedCityObject.value = storeCache.get('searchSelectedCity');
}

onMounted(() => {
    Promise.all([
        searchTranslatorFiltersStore.fetchAvailableLangs(),
        searchTranslatorFiltersStore.fetchAvailableTranslationsTypes(),
        searchTranslatorFiltersStore.fetchAvailableLocations(),
    ]).then(res => {
        fetchAllData.value = true;
        fetchCurrentParams();
    });
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["md:flex md:justify-between md:items-end search-bar md:block", { 'hidden': !showFilters.value && __props.togglingMobileFilters }])
    }, [
      _createVNode(AutocompletePrimary, {
        "selected-item": selectedLanguageObject.value?.value ?? 1,
        "selected-item-key": "id",
        itemsNameKey: "name",
        itemsValueKey: "id",
        label: _ctx.$t('searchSection.langLabel'),
        "custom-class": {'outline outline-rose-700 outline-1': requiredLang.value},
        onOnSelect: selectedLanguage,
        onOnInput: searchTermLanguage,
        items: _unref(availableLangs),
        id: "lang"
      }, null, 8, ["selected-item", "label", "custom-class", "items"]),
      _createVNode(AutocompletePrimary, {
        onOnSelect: selectedTypes,
        onOnInput: selectedTermTypes,
        label: _ctx.$t('searchSection.translationTypeLabel'),
        items: _unref(availableTranslationTypes),
        itemsNameKey: "name",
        itemsValueKey: "id",
        "selected-item": selectedTranslationTypeObject.value?.value ?? 0,
        "selected-item-key": "id",
        "custom-class": {'outline outline-rose-700 outline-1': requiredTranslated.value},
        id: "translatorType"
      }, null, 8, ["label", "items", "selected-item", "custom-class"]),
      _createVNode(AutocompletePrimary, {
        onOnSelect: selectedLocation,
        label: _ctx.$t('searchSection.locationLabel'),
        items: _unref(availableLocations),
        itemsNameKey: "name",
        itemsValueKey: "id",
        callback: searchCity,
        onOnInput: searchTermCity,
        "selected-item": selectedCityObject.value?.value ?? 90,
        "selected-item-key": "id",
        "custom-class": {'outline outline-rose-700 outline-1': requiredCity.value},
        id: "city"
      }, null, 8, ["label", "items", "selected-item", "custom-class"]),
      _createVNode(ButtonPrimary, {
        onClick: goToSearch,
        name: _ctx.$t('searchSection.search'),
        class: "self-end w-full md:w-auto"
      }, null, 8, ["name"]),
      (__props.togglingMobileFilters)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "w-[0.5rem] -rotate-90",
              alt: _ctx.$t('homeView.contactTheTranslatorIconAlt')
            }, null, 8, _hoisted_2),
            _createElementVNode("span", {
              class: "text-light-secondary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showFilters.value = false), ["prevent"]))
            }, _toDisplayString(_ctx.$t('searchSection.hideFilters')), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.togglingMobileFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!showFilters.value)
            ? (_openBlock(), _createBlock(ButtonPrimary, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showFilters.value = true), ["prevent"])),
                name: _ctx.$t('searchSection.showFilters'),
                class: "w-full"
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.sortSection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(__props.count) + " " + _toDisplayString(_ctx.$t('searchSection.outOf')) + " " + _toDisplayString(__props.totalCount) + " " + _toDisplayString(_ctx.$t('searchSection.resultsCounter')), 1),
            _createVNode(SwitchButton, {
              modelValue: toggleSwitch.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (toggleSwitchEvent($event))),
              title: _ctx.$t('searchSection.interpreting')
            }, null, 8, ["modelValue", "title"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ButtonPrimary, {
              onClick: updateList,
              name: _ctx.$t('searchSection.list'),
              class: "w-full flex-1",
              outlined: "",
              disabled: chooseMap.value
            }, null, 8, ["name", "disabled"]),
            _createVNode(ButtonPrimary, {
              onClick: updateMap,
              name: _ctx.$t('searchSection.map'),
              class: "w-full flex-1",
              outlined: "",
              disabled: chooseList.value
            }, null, 8, ["name", "disabled"])
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})